import ResizeController from '../../../assets/js/controllers/resize';

import { multiClassList, multiAddEventListener, multiRemoveEventListener } from '../../../assets/js/helpers';

// constants
import Platform from '../../../assets/js/constants/platform';
import CursorEvent from '../../../bits/cursor/cursor-event';
import ProgressEvent from '../../../bits/progress/progress-event';
import SliderDraggableEvent from '../../../components/slider-draggable/slider-draggable-event';

export default class GalleryTeam {

	static selector = 'gallery-team';

	// class variables

	controllers = {
		resize: null
	};

	el = {};

	flags = {
		isCursorEnabled: true
	};

	states = {
		buttonActive: null,
		buttonClickTimeStart: 0,
		scrollRatio: 0
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			cursor: container.querySelector(`.${this.constructor.selector}__cursor`),
			progress: container.querySelector(`.${this.constructor.selector}__progress`),
			scrollWrapper: container.querySelector(`.${this.constructor.selector}__scroll-wrapper`),
			scrollItemsWrapper: container.querySelector(`.${this.constructor.selector}__scroll-wrapper > ul`),
			slider: container.querySelector('[data-slider-draggable]'),
			sliderItems: container.querySelectorAll('[data-slider-draggable-item]'),
			sliderItemButtons: container.querySelectorAll('[data-slider-draggable-item] a'),
			sliderItemsText: container.querySelectorAll(`.${this.constructor.selector}__item-text-wrapper`)
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		document.addEventListener('mouseleave', this.#onDocumentMouseLeave);

		// check whether clicking anywhere in slider area will trigger an edge slide change
		this.el.slider.addEventListener('click', this.#onSliderClick);

		// listen for changes in the slider
		this.el.slider.addEventListener(SliderDraggableEvent.CHANGE_ACTIVE, this.#onSliderChangeActive);
		this.el.slider.addEventListener(SliderDraggableEvent.DRAG_START, this.#onSliderDragging);
		this.el.slider.addEventListener(SliderDraggableEvent.SCROLL, this.#onSliderScroll);

		multiAddEventListener(this.el.sliderItemButtons, 'touchstart', this.#onSliderButtonMouseDown);
		multiAddEventListener(this.el.sliderItemButtons, 'mousedown', this.#onSliderButtonMouseDown);
		multiAddEventListener(this.el.sliderItemButtons, 'click', this.#onSliderButtonMouseClick);

		multiAddEventListener(this.el.sliderItemsText, 'mouseenter', this.#onSliderItemTextOver);
		multiAddEventListener(this.el.sliderItemsText, 'mouseleave', this.#onSliderItemTextOut);
	}

	#removeEventListeners = () => {
		document.removeEventListener('mouseleave', this.#onDocumentMouseLeave);
		document.removeEventListener('mouseup', this.#onDocumentMouseUp);

		this.el.slider.removeEventListener('click', this.#onSliderClick);

		this.el.slider.removeEventListener(SliderDraggableEvent.CHANGE_ACTIVE, this.#onSliderChangeActive);
		this.el.slider.removeEventListener(SliderDraggableEvent.DRAG_START, this.#onSliderDragging);
		this.el.slider.removeEventListener(SliderDraggableEvent.SCROLL, this.#onSliderScroll);

		multiRemoveEventListener(this.el.sliderItemButtons, 'touchstart', this.#onSliderButtonMouseDown);
		multiRemoveEventListener(this.el.sliderItemButtons, 'mousedown', this.#onSliderButtonMouseDown);
		multiRemoveEventListener(this.el.sliderItemButtons, 'click', this.#onSliderButtonMouseClick);

		multiRemoveEventListener(this.el.sliderItemsText, 'mouseenter', this.#onSliderItemTextOver);
		multiRemoveEventListener(this.el.sliderItemsText, 'mouseleave', this.#onSliderItemTextOut);
	}

	// listener methods

	#onDocumentMouseLeave = () => {
		if (this.states.buttonActive) {
			document.removeEventListener('mouseup', this.#onDocumentMouseUp);
			document.removeEventListener('touchend', this.#onDocumentMouseUp);
			this.states.buttonActive = null;
		}
	}

	#onSliderClick = () => {
		if (this.flags.isCursorEnabled) {
			if (this.el.cursor.classList.contains('is-edge-left')) {
				this.el.slider.dispatchEvent(new Event(SliderDraggableEvent.PREV));
			} else if (this.el.cursor.classList.contains('is-edge-right')) {
				this.el.slider.dispatchEvent(new Event(SliderDraggableEvent.NEXT));
			}
		}
	}

	#onSliderChangeActive = (e) => {
		const index = parseInt(e.detail.index);
		if (!isNaN(index)) {
			// const ratio = index / (this.el.sliderItems.length - 1);
			// this.el.progress.dispatchEvent(new CustomEvent(ProgressEvent.ADJUST, { detail: { ratio } }));
		}
	}

	#onSliderDragging = () => {
		multiClassList(this.el.sliderItems, 'remove', 'is-active');
	}

	#onSliderScroll = (e) => {
		const { ratio } = e.detail;
		this.el.progress.dispatchEvent(new CustomEvent(ProgressEvent.ADJUST, { detail: { ratio } }));
	}

	#onSliderButtonMouseDown = (e) => {
		document.addEventListener('mouseup', this.#onDocumentMouseUp);
		document.addEventListener('touchend', this.#onDocumentMouseUp);
		this.states.buttonClickTimeStart = Date.now();
		this.states.buttonActive = e.currentTarget;

		if (ResizeController.platform === Platform.DESKTOP) {
			e.preventDefault();
		}
	}

	#onSliderButtonMouseClick = (e) => {
		e.preventDefault();
	}

	#onDocumentMouseUp = () => {
		if (this.states.buttonActive && Date.now() - this.states.buttonClickTimeStart < 250) {
			document.removeEventListener('mouseup', this.#onDocumentMouseUp);
			location.href = this.states.buttonActive.getAttribute('href');
			this.states.buttonActive = null;
		}
	}

	#onSliderItemTextOver = () => {
		this.cursorHide();
	}

	#onSliderItemTextOut = () => {
		this.cursorShow();
	}

	// controller methods

	#onResizeUpdate = () => {
		this.measureResize();
		return true;
	}

	#onResizeRender = () => {

	}

	//

	measureResize() {

	}

	// cursor

	cursorHide() {
		this.flags.isCursorEnabled = false;
		this.el.cursor.dispatchEvent(new Event(CursorEvent.HIDE));
	}

	cursorShow() {
		this.flags.isCursorEnabled = true;
		this.el.cursor.dispatchEvent(new Event(CursorEvent.SHOW));
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
